import { c as _c } from "react/compiler-runtime";
import { track } from "@opensea/analytics";
import { Image, Link } from "@opensea/next-ui-kit";
import { createConfig, CoreWalletProvider as WalletProviderBase } from "@opensea/wallet";
import { captureException } from "@sentry/nextjs";
import { useState } from "react";
import { WagmiProvider } from "wagmi";
import { useReferralParam } from "@/hooks/use-referral-param";
import { toWalletCurrencies } from "@/lib/currencies";
import { trackError as trackErrorDatadog } from "../../lib/integrations/datadog";
import { WalletAnalyticsHandler } from "./analytics";
import { getConnectors } from "./connectors";
import { FlagContextHandler } from "./flags";
import { useWalletFlags } from "./flags/use-wallet-flags";
import { siweAdapter } from "./siwe-adapter";
export function WalletProvider(t0) {
  const $ = _c(19);
  const {
    children,
    chains,
    initialCurrencies,
    connectors
  } = t0;
  let t1;
  if ($[0] !== chains) {
    t1 = chains.filter(_temp);
    $[0] = chains;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const evmChains = t1;
  let t2;
  if ($[2] !== connectors || $[3] !== evmChains) {
    t2 = () => {
      const sortedEvmChains = evmChains?.sort(_temp2);
      return createConfig({
        chains: sortedEvmChains,
        connectors: connectors ?? getConnectors(),
        ssr: true
      });
    };
    $[2] = connectors;
    $[3] = evmChains;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const [wagmiConfig] = useState(t2);
  const flags = useWalletFlags();
  const [flagsReady, setFlagsReady] = useState(false);
  useReferralParam();
  let t3;
  if ($[5] !== initialCurrencies) {
    t3 = toWalletCurrencies(initialCurrencies);
    $[5] = initialCurrencies;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  let t5;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <FlagContextHandler setReady={setFlagsReady} />;
    t5 = <WalletAnalyticsHandler />;
    $[7] = t4;
    $[8] = t5;
  } else {
    t4 = $[7];
    t5 = $[8];
  }
  let t6;
  if ($[9] !== chains || $[10] !== children || $[11] !== flags || $[12] !== flagsReady || $[13] !== t3 || $[14] !== wagmiConfig) {
    t6 = <WalletProviderBase acceptTermsEnabled={true} chains={chains} flags={flags} flagsReady={flagsReady} initialCurrencies={t3} renderImage={renderImage} renderLink={renderLink} siweAdapter={siweAdapter} trackError={trackError} trackEvent={track} wagmiConfig={wagmiConfig}>{children}{t4}{t5}</WalletProviderBase>;
    $[9] = chains;
    $[10] = children;
    $[11] = flags;
    $[12] = flagsReady;
    $[13] = t3;
    $[14] = wagmiConfig;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  let t7;
  if ($[16] !== t6 || $[17] !== wagmiConfig) {
    t7 = <WagmiProvider config={wagmiConfig}>{t6}</WagmiProvider>;
    $[16] = t6;
    $[17] = wagmiConfig;
    $[18] = t7;
  } else {
    t7 = $[18];
  }
  return t7;
}
function _temp2(a, b) {
  return a.networkId - b.networkId;
}
function _temp(chain) {
  return chain.arch === "EVM";
}
const renderLink = ({
  href,
  ...restProps
}) => {
  if (!href) {
    throw new Error("Link component requires an href prop");
  }
  return <Link href={href} {...restProps} />;
};
const renderImage = props => {
  return <Image height={props.height ?? props.size} width={props.width ?? props.size} {...props} />;
};
const trackError = (error, context) => {
  console.error(error, context);

  // Only send to Sentry if not explicitly skipped
  let errorId;
  if (!context?.extra?.skipSentry) {
    errorId = captureException(error, context);
  }
  void trackErrorDatadog(error, context);

  // Still track in Amplitude regardless
  if (context?.extra?.type === "blockchain-action-error") {
    void track("Blockchain Action Error", {
      error: error.message,
      errorName: error.name,
      errorId,
      cause: error.cause?.message,
      ...context
    });
  }
  return errorId;
};